import { Injectable, inject } from "@angular/core";
import {
  SelfServDataService,
  ISelfServMeta,
  AppConfigService,
  SelfServMetaWireSchema,
  validateWireAs,
} from "@aa/common";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class SelfServMetaCacheService {
  private readonly dataService = inject(SelfServDataService);
  private readonly appConfig = inject(AppConfigService);

  meta: ISelfServMeta | null = null;
  errorStatus = 0;

  public get metaSafe(): ISelfServMeta {
    if (!this.meta) {
      throw new Error("SelfServMetaCacheService meta is not initialized");
    }

    return this.meta;
  }

  // called by app initializer in core module
  public init(selfServDomain?: string): Promise<void> {
    // First check the server-injected global meta. Unlike the getMeta() HTTP
    // path (validated inside SelfServDataService), this global bypasses the
    // funnel, so validate it here against the same wire schema. Only validate
    // when something was injected; an absent global falls through to getMeta.
    const injected = (window as any)["selfServMeta"];
    if (injected) {
      const meta = validateWireAs<ISelfServMeta>(
        SelfServMetaWireSchema,
        injected,
      );
      this.setMeta(meta);
      return Promise.resolve();
    }

    if (!selfServDomain) {
      // console.warn('selfServDomain is is undefined');
      return Promise.reject("selfServDomain is undefined");
    }

    return firstValueFrom(this.dataService.getMeta(selfServDomain)).then(
      (meta) => {
        this.setMeta(meta);
      },
      (error) => {
        this.errorStatus = error.status;
        console.warn("Failed to get self serv meta data", error);
      },
    );
  }

  private setMeta(meta: ISelfServMeta) {
    this.appConfig.setAnalyticsContext({
      teamName: meta.teamName,
      domain: meta.domain,
    });

    this.meta = meta;
  }
}
